/**
 * The one support session icon, used by the top toolbar's icon button
 * (CobrowseButton) and the status strip's text button (BottomToolbar).
 *
 * The two used different icons (a screen-share glyph above, a monitor below),
 * so one action looked like two different things, and both sat in the same
 * grey as every other toolbar icon. Now one headset in both places, in its own
 * accent colour (--support-accent; globalStyles.css), green while a session
 * is running.
 */
export default function SupportSessionIcon({ active = false }: { active?: boolean }) {
  return (
    <i
      className={`bi bi-headset support-session-icon${active ? ' is-active' : ''}`}
      aria-hidden="true"
    />
  );
}
